export const MS_PER_DAY = 24 * 60 * 60 * 1000;
export const WEEKLY_CAP_MS = 7 * MS_PER_DAY;
export const LONG_SNOOZE_DAYS = 60;
export const MIN_QUIZ_QUESTIONS = 3;
// Courses not accessed within this many days are considered too stale for a meaningful quiz.
export const STALE_COURSE_DAYS = 60;
export const UDEMY_LOGO_CDN_URL =
    'https://frontends.udemycdn.com/frontends-logged-in-homepages/staticx/udemy/images/v7/logo-udemy.svg';
